import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/fjSeo1rtLWiz852wtBaDZL/SS_Logo.png';
interface SalesSourceLogoProps {
  /** Height of the bronze monogram tile in pixels. */
  size?: number;
  /** Show the "Sales Source" wordmark next to the monogram. */
  withWordmark?: boolean;
  className?: string;
}

/**
 * The uploaded logo is a stacked lockup on white, so the monogram is cropped out
 * of it and paired with live type — that keeps the mark crisp at header sizes.
 */
export function SalesSourceLogo({
  size = 36,
  withWordmark = true,
  className = ''
}: SalesSourceLogoProps) {
  return <span className={`inline-flex items-center gap-3 ${className}`} data-id="element-168" data-mp="3fvmm4a65a5kz">
      <span className="relative shrink-0 overflow-hidden rounded-lg" style={{
      height: size,
      width: size,
      backgroundColor: 'var(--s-logo-plate)'
    }} data-id="element-169" data-mp="3b4mot3t45lhy">
        <img src={LOGO_URL} alt="Sales Source" className="absolute max-w-none" style={{
        width: '202%',
        height: '202%',
        left: '-52.5%',
        top: '-26.4%'
      }} data-id="element-170" data-mp="2ncz79chqrmsc" />
      </span>

      {withWordmark && <span className="leading-none" data-id="element-171" data-mp="2kpaobl5yqsp5">
          <span className="block font-display font-bold leading-none tracking-tight text-shell-text" style={{
        fontSize: size * 0.62
      }} data-id="element-172" data-mp="2ko9etl4lie9j">
            Sales Source
          </span>
          <span className="mt-1 block font-mono uppercase tracking-[0.2em] text-shell-faint" style={{
        fontSize: Math.max(8, size * 0.22)
      }} data-id="element-173" data-mp="2tk8lx5k22tmt">
            Conference sales
          </span>
        </span>}
    </span>;
}